/**
 * Доступность записи — кому она видна.
 *
 * Числовые значения обязаны совпадать с `server/config/postAccess.js`: там же
 * лежит и само правило видимости. Здесь — только то, что нужно показать в
 * настройках записи.
 */
export const POST_ACCESS = {
    PUBLIC: 0,
    SUBSCRIBERS: 1,
    SUBSCRIPTIONS: 2,
    BOTH: 3,
    LINK: 4,
};

export const POST_ACCESS_OPTIONS = [
    {
        value: POST_ACCESS.PUBLIC,
        label: 'Открытый доступ',
        description: 'Запись видят все',
    },
    {
        value: POST_ACCESS.SUBSCRIBERS,
        label: 'Доступ подписчикам',
        description: 'Видят те, кто подписан на вас',
    },
    {
        value: POST_ACCESS.SUBSCRIPTIONS,
        label: 'Доступ подпискам',
        description: 'Видят те, на кого подписаны вы',
    },
    {
        value: POST_ACCESS.BOTH,
        label: 'Доступ подписчикам и подпискам',
        description: 'Видят и те, и другие',
    },
    {
        value: POST_ACCESS.LINK,
        label: 'Доступ по ссылке',
        description: 'Не показывается в ленте и профиле, открывается по прямой ссылке',
    },
];

/** Значение из ответа сервера — к допустимому варианту. */
export function normalizeAccess(value) {
    const number = Number(value);
    return POST_ACCESS_OPTIONS.some(o => o.value === number) ? number : POST_ACCESS.PUBLIC;
}
